export default "/react/yadzen-3f9e4720.svg";